import TH_PluginBase from "_tradeholding/js/Classes/PluginBase";

export default TH_PluginBase;